<div [class.dark]="dark" class="time-picker-time-zone-picker-wrap">
  <div class="time-zone-header" (click)="$event.preventDefault(); $event.stopPropagation()">
    <rt-form-field variant="underlined search">
      <rt-icon name="search"></rt-icon>
      <rt-input
        #searchInput
        [autoFocus]="true"
        [hasClearButton]="!isEmpty"
        (input)="onInputChange($event)"
        (click)="$event.preventDefault()"
        (reset)="clearField()"
        variant="underlined"
        placeholder="{{ 'rtu.common.search' | translate }}"
      >
      </rt-input>
    </rt-form-field>
  </div>
  <div class="zones-list-container">
    <div
      *ngFor="let zone of filteredZones; trackBy: trackByZone"
      (click)="this.zoneSelect.emit(zone)"
      class="zone-item clickable"
    >
      {{ zone }}
    </div>
    <div *ngIf="!filteredZones.length" class="zone-item">
      {{ 'rtu.ui.select.no_results' | translate }}
    </div>
  </div>
</div>
